<div>
  <router-outlet></router-outlet>
  <app-gaggle-full-page-spinner [showSpinner]="showFullPageSpinner"></app-gaggle-full-page-spinner>
</div>
